export default __webpack_public_path__ + "static/media/480_business06-fr-mobile.4e9554ee.png";